<nav class="breadcrumb-trilha mt-3" aria-label="Você está em">
  <ol class="breadcrumb-lista">
    <li class="breadcrumb-trilha-item">
      <a class="breadcrumb-link" routerLink="/homepage">Início</a>
    </li>

    @for (item of intermediarios(); track item.link) {
    <li class="breadcrumb-trilha-item">
      <i-lucide class="breadcrumb-separador" name="chevron-right" size="16" aria-hidden="true"></i-lucide>
      <a class="breadcrumb-link" [routerLink]="item.link">{{ item.titulo }}</a>
    </li>
    }

    <li class="breadcrumb-trilha-item">
      <i-lucide class="breadcrumb-separador" name="chevron-right" size="16" aria-hidden="true"></i-lucide>
      <span class="breadcrumb-atual" aria-current="page">{{ pagina() }}</span>
    </li>
  </ol>
</nav>